var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content change-charge-window",
      attrs: {
        visible: _vm.innerVisible,
        "close-on-click-modal": false,
        "destroy-on-close": true,
        title: _vm.$t("ChangeCharge.ChangeCharge"),
        width: "1300px",
        "before-close": _vm.cancel
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "config-module": "19110101",
              "row-data": _vm.rowData,
              "min-height": "300px"
            }
          })
        ],
        1
      ),
      _vm.editable
        ? _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "div",
              { staticStyle: { float: "right", "margin-bottom": "10px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini", no: "1" },
                    on: { click: _vm.saveEvent }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", no: "2" },
                    on: { click: _vm.cancel }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }